!function (a, b, c, d, e, f) {
  a.ddjskey = e;
  a.ddoptions = f || null;
  var m = b.createElement(c), n = b.getElementsByTagName(c)[0];
  m.async = 1, m.src = d, n.parentNode.insertBefore(m, n);
}(window, document, "script", "https://datadome.alltrails.com/tags.js","9D463B509A4C91FDFF39B265B3E2BC", { ajaxListenerPath: true, allowHtmlContentTypeOnCaptcha: true });